export default __webpack_public_path__ + "static/media/bbb.aecb8143.png";